
class User {
    constructor(_request) {
        this.request = _request;
    }

    bookings(page) {
        let url = `user/bookings`;
        if(page) {
            url = `${url}/${page}`;
        }
        return this.request.fetch({
            method: "GET",
            endpoint: url
        });
    }
}

export default User;
